import * as React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, IconButton, Box, Button, CircularProgress,
  Stack, Tabs, Tab, Typography, TableContainer, Table, TableHead,
  TableRow, TableCell, TableBody, Paper,
  TablePagination
} from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import { useState, useEffect } from 'react';
import { Crypter } from '../Functions/Security/Crypter';
import SweetAlert from 'sweetalert2';
import Datas from "../Data/Data.json";
import axios from 'axios';
import { useAuthHeader } from '../Services/Auth/sessionAuth';
import DataType from '../Types/DataTablePiclist';
import ParamsPicklist from '../Types/ParamsPicklist';
import { Form } from 'antd';

interface SearchModalProps {
  Titre: string;
  label: string;
  name: string;
  data?: any;
  Taille1?: number | string;
  Taille2?: number | string;
  Parametre?: ParamsPicklist;
  form?: any;
  notRequired?: true;
  defaultCode?: string;
  defaultLibelle?: string;
  width?: number | string;
  disabledCode?: boolean;
  disabledLibell?: boolean;
  handleFunction?: any;
  ExecuteafterSelect1?: any;
  ExecuteafterSelect2?: any;
  notremove?: true;
}

const SearchModalMUI = (props: SearchModalProps) => {
  const [open, setOpen] = useState(false);
  const [libelle, setLibelle] = useState(props.defaultLibelle || '');
  //const [libelle, setLibelle] = useState();
  const [code, setCode] = useState(props.defaultCode || '');
  const [data, setData] = useState<DataType[]>(props.data || []);
  const [searchTerm, setSearchTerm] = useState('');
  const [tabValue, setTabValue] = useState(2); // Default tab is "All"
  const [loading, setLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [page, setPage] = useState(0);
 const [rowsPerPage, setRowsPerPage] = useState(5);
 //const [libelle, setLibelle] = useState('');

  const authHeader = useAuthHeader();

  useEffect(() => {
    console.log("Libellé:", libelle);
    if (props.form && props.defaultCode) {
      
      props.form.setFieldValue(props.name, props.defaultCode);
      props.form.setFieldValue("lib_" + props.name, props.defaultLibelle);
      //props.form.setFieldValue("lib_" + props.name, libelle);
    }
  }, [libelle]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setSearchTerm('');
    setOpen(false);
  };

  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCode(e.target.value);
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleLibelleChange = (e:React.ChangeEvent<HTMLInputElement>) => {
  const upperValue = e.target.value.toLocaleUpperCase();
  setLibelle(upperValue); // ✅ Stocke directement en majuscules
};

  const fetchData = async (init: string, choix: number) => {
    setLoading(true);
    const requestData = {
      CodeAgence: props.Parametre?.CodeAgence,
      Table: props.Parametre?.Table,
      Colonne1: props.Parametre?.Colonne1,
      Colonne2: props.Parametre?.Colonne2,
      Colagence: props.Parametre?.Colagence,
      Init: init,
      choix: choix,
      colfiltre: props.Parametre?.colfiltre,
      valfiltre: props.Parametre?.valfiltre
    };

    try {
      const response = await axios.get(Datas.ApiUrl.AnySearch, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherSearch': Crypter.encrypt(JSON.stringify(requestData))
        }
      });

      const decrypted = JSON.parse(Crypter.decrypt(response.data)).Value;
      if (decrypted.StatutCode === 200) {
        const result = decrypted.Result.Table;
        const mapped: DataType[] = result.map((item: any, index: number) => ({
          key: index,
          Code: item[Object.keys(item)[1]],
          Libelle: item[Object.keys(item)[0]]
        }));
        setData(mapped);

        if (mapped.length === 1) {
          handleSelect(mapped[0]);
        } else if (mapped.length === 0 && !props.notremove) {
          resetFields();
        }
      } else {
        if (!props.notremove) resetFields();
      }
    } catch (error: any) {
      console.error(error);
      SweetAlert.fire({ title: "Erreur", text: error.message, icon: "error" });
    } finally {
      setLoading(false);
      setSearchLoading(false);
    }
  };

  const handleSearch = (e: React.KeyboardEvent<HTMLInputElement> | undefined) => {
    if ((e?.key === 'Tab' || e === undefined) && code.trim() !== '') {
      setSearchLoading(true);
      fetchData(code, 1);
    }
  };

  const handleSelect = (item: DataType) => {
    setCode(item.Code);
    setLibelle(item.Libelle);
    props.form.setFieldValue(props.name, item.Code);
    props.form.setFieldValue("lib_" + props.name, item.Libelle);
    setOpen(false);

    if (props.handleFunction) props.handleFunction(item.Code);
    if (props.ExecuteafterSelect1) props.ExecuteafterSelect1();
    if (props.ExecuteafterSelect2) props.ExecuteafterSelect2();
  };

  const resetFields = () => {
    setCode('');
    setLibelle('');
    props.form.setFieldValue(props.name, '');
    props.form.setFieldValue("lib_" + props.name, '');
  };

  return (
    <Box display="flex" flexDirection="column" sx={{ mb: 1 }}>
      {/* <Typography variant="subtitle2" gutterBottom>{props.label}</Typography> */}
    <Box display="flex" gap={1} width="100%">
  {/* Champ Code avec largeur fixe */}
  <Form.Item
    initialValue={props.defaultCode}
    rules={[{ required: !props.notRequired, message: "" }]}
    name={props.name}
    style={{ marginBottom: 0 }}
  >
    <TextField
      label={props.label}
      value={props.form.getFieldValue(props.name) || ""}
      onChange={(e) => props.form.setFieldValue(props.name, e.target.value)}
      disabled={props.disabledCode}
      size="small"
      onBlur={() => handleSearch(undefined)}
      variant="outlined"
      InputLabelProps={{ shrink: true }}
      InputProps={{
        endAdornment: (
          <IconButton
            onClick={handleOpen}
            disabled={props.disabledCode}
            sx={{ color: '#116599' }}
          >
            <SearchIcon />
          </IconButton>
        ),
      }}
      sx={{
       // width: 150, // ✅ largeur fixe ici (modifie à ta convenance)
       width: props.width || 150,
        borderRadius: 1,
        '& .MuiInputLabel-root': {
          fontWeight: 'bold',
          fontSize: '18px',
        },
      }}
    />
  </Form.Item>

  {/* Champ Libellé qui prend le reste de l'espace */}
  <Form.Item
    initialValue={props.defaultLibelle?.toLocaleUpperCase()}
    name={"lib_" + props.name}
    style={{ marginBottom: 0, flex: 1 }} // ✅ le champ prend le reste
  >
    <TextField
      fullWidth
      value={libelle}
      label=" "
      variant="outlined"
      onChange={(e) => setLibelle(e.target.value.toLocaleUpperCase())}
      disabled={props.disabledLibell}
      size="small"
      InputLabelProps={{ shrink: true }}
      InputProps={{
        endAdornment: searchLoading ? <CircularProgress size={18} /> : null,
      }}
      inputProps={{
        style: {
          textTransform: 'uppercase',
        },
      }}
      sx={{
        borderRadius: 1,
        '& .MuiInputLabel-root': {
          fontWeight: 'bold',
          fontSize: '18px',
        },
      }}
    />
  </Form.Item>
</Box>


      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>{props.Titre}</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2}>
            {/* <Tabs value={tabValue} onChange={handleTabChange} aria-label="search-tabs">
              <Tab label="Identifiant" />
              <Tab label="Libellé" />
              <Tab label="Tous" />
            </Tabs> */}

            {/* {tabValue === 0 && (
              <TextField
                label="Identifiant"
                fullWidth
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            )}
            {tabValue === 1 && (
              <TextField
                label="Libellé"
                fullWidth
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            )} */}
            {tabValue === 2 && (
              <Box display="flex" gap={2}>
                <TextField
                  autoFocus={true}
                  label="Recherche"
                  fullWidth
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  size='small'
                  sx={{ borderRadius: 10 }}
                   onKeyDown={(e) => {
                  if (e.key === 'Enter') {
            
                       //handleSearch(undefined); // ou passe l'événement si tu as besoin
                      fetchData((e.target as HTMLInputElement).value, props.Parametre?.Choix || 22)
                        }
                      }}
                />
                   <IconButton
                         color="primary"
                         onClick={() => fetchData(searchTerm, props.Parametre?.Choix || 22)}
                         aria-label="Rechercher"
                            >
                     <SearchIcon /> {/* ou n’importe quelle icône */}
                    </IconButton>
              </Box>
            )}
          </Stack>

          <TableContainer component={Paper} sx={{ mt: 2, maxHeight: 300 }}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ color: '#fff', py: 1.5,backgroundColor:" #116599", }}>Code</TableCell>
                  <TableCell sx={{ color: '#fff', py: 1.5,backgroundColor:" #116599", }}>Libellé</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                 {data
                 .filter((row) => {
                 const lowerSearch = searchTerm.toLowerCase();
                     return (
                       (row.Code?.toLowerCase().includes(lowerSearch) || '') ||
                       (row.Libelle?.toLowerCase().includes(lowerSearch) || '')
                        );
                         })
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row,index) => (
                   <TableRow
                   key={row.key}
                   hover
                   onClick={() => handleSelect(row)}
                   sx={{ cursor: 'pointer',
                    backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#ffffff',
                                                     '&:hover': {
                                                      // backgroundColor: '#e6f0f8', // Couleur au survol
                                                     // background: `linear-gradient(90deg, #0d4a70 0%, #116599 100%)`,
                                                      //color: '#fff', // Texte blanc sur fond sombre
                                                      background: 'linear-gradient(90deg, #eaf2fa 0%, #e0eef8 100%)',
                                                        },
                    }}
                 >
                <TableCell>{row.Code}</TableCell>
                 <TableCell>{row.Libelle}</TableCell>
                </TableRow>
                 ))}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
             component="div"
                count={data.length}
                 page={page}
                 onPageChange={(event, newPage) => setPage(newPage)}
                 rowsPerPage={rowsPerPage}
                 onRowsPerPageChange={(event) => {
                   setRowsPerPage(parseInt(event.target.value, 10));
                    setPage(0);
                      }}
                     rowsPerPageOptions={[5, 10, 25, { label: 'Tout afficher', value: data.length }]}
            />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Fermer</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SearchModalMUI;
